import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type TeamFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const TeamFilled = forwardRef<SVGSVGElement, TeamFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-2.842104 -2.841294) scale(1.236842)">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.816 8.50469C14.816 10.0315 13.5607 11.2529 12.0678 11.2529C10.541 11.2529 9.31961 10.0315 9.31961 8.50469C9.31961 6.9779 10.541 5.75647 12.0678 5.75647C13.5946 5.75647 14.816 6.9779 14.816 8.50469ZM12.0678 13.7297L13.7982 11.7279C15.5964 12.5422 16.8857 14.544 16.8517 16.919C16.8517 17.2243 16.8178 17.5636 16.7839 17.869C15.766 19.1583 14.0357 20.0065 12.0678 20.0065C10.1 20.0065 8.36961 19.1583 7.35175 17.869C7.31782 17.5636 7.28389 17.2583 7.28389 16.919C7.28389 14.544 8.57318 12.5422 10.3714 11.7279L12.0678 13.7297ZM15.7321 8.67433V8.50469C15.7321 7.4529 15.291 6.53683 14.6125 5.85826C14.9178 4.80647 15.9017 3.99219 17.0553 3.99219C18.4464 3.99219 19.566 5.14576 19.566 6.53683C19.566 7.9279 18.4464 9.04754 17.0553 9.04754C16.5464 9.04754 16.1053 8.91183 15.7321 8.67433ZM8.36961 8.57254C7.96246 8.8779 7.45353 9.04754 6.91068 9.04754C5.51961 9.04754 4.36603 7.89397 4.36603 6.53683C4.36603 5.11183 5.51961 3.99219 6.91068 3.99219C8.13211 3.99219 9.14996 4.8404 9.38746 5.99397C8.74282 6.63862 8.36961 7.52076 8.36961 8.50469V8.57254ZM17.0554 11.3547L18.65 9.48859C20.3125 10.235 21.5 12.1011 21.5 14.3404C21.5 14.6177 21.472 14.8671 21.4415 15.1393C21.4384 15.1668 21.4353 15.1945 21.4321 15.2225C20.6518 16.2065 19.3286 16.9529 17.8357 17.1225V16.9529C17.8357 14.4422 16.5804 12.2029 14.6464 11.1172C15.0536 10.71 15.3929 10.2011 15.5625 9.62431L17.0554 11.3547ZM8.50536 9.48859C8.675 10.0993 9.04821 10.6761 9.48929 11.1172C7.55536 12.2368 6.33393 14.4422 6.33393 16.919V17.1225C4.77321 16.9868 3.41607 16.2404 2.56786 15.1886C2.53393 14.9172 2.5 14.6118 2.5 14.3065C2.5 12.135 3.6875 10.235 5.31607 9.48859L6.91071 11.3547L8.50536 9.48859Z" />
      </g>
    </svg>
  ),
);

TeamFilled.displayName = 'TeamFilled';

export default TeamFilled;
